import React, { useEffect, useState } from "react";
import { Route, Redirect } from "react-router-dom";
import { GetData } from "./Api";
var _ = require('lodash');

const ProtectedRoute = (props) => {

  const { component: Component, exact, ...rest } = props;

  const [userSession, setuserSession] = useState(false);
  const [processing, setprocessing] = useState(true);

  const IdentifyUser = () => {
    GetData('api/auth/user', true).then(() => {
      setuserSession(true);
      setprocessing(false);
    }).catch(()=>{
      setuserSession(false);
      setprocessing(false);
    });
  }

  const IdentifyToken = () => {
    let token = localStorage.getItem("token");
    if(_.isEmpty(token)){
      setuserSession(false);
      setprocessing(false);
    }else{
      IdentifyUser();
    }
  }

  useEffect(() => {
    IdentifyToken();
  }, [])

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!processing) {
          if(userSession){
            return <Component {...props} />;
          }else{
            return <Redirect to="login" />;
          }
        }
      }}
      exact={exact}
    />
  );
};

export default ProtectedRoute;